var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9489 0.779297H8.61312V2.23914H10.2189V4.98851C10.2189 7.40336 8.25422 9.36808 5.83937 9.36808C3.42453 9.36808 1.45984 7.40339 1.45984 4.98855V2.23914H3.01703V0.779297H0.729922C0.326758 0.779297 0 1.10605 0 1.50922V4.98855C0 8.20851 2.61945 10.828 5.83941 10.828C9.05937 10.828 11.6788 8.20851 11.6788 4.98855V1.50922C11.6788 1.10605 11.3521 0.779297 10.9489 0.779297Z",
    fill: "#041967"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7943 11.4379V14.8929C13.7943 16.9053 12.1571 18.5425 10.1446 18.5425C8.13223 18.5425 6.495 16.9053 6.495 14.8929V10.124H5.03516V14.8929C5.03516 17.7102 7.32711 20.0024 10.1446 20.0024C12.9619 20.0024 15.2541 17.7102 15.2541 14.8929V11.4379H13.7943Z",
    fill: "#041967"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5262 6.7168C13.0366 6.7168 11.8252 7.92824 11.8252 9.41754C11.8252 10.9066 13.0366 12.1183 14.5259 12.1183C16.0152 12.1183 17.2267 10.9066 17.2269 9.41754C17.2269 7.92824 16.0152 6.7168 14.5262 6.7168ZM14.5259 10.6584C13.8415 10.6584 13.2848 10.1018 13.2848 9.41758C13.2848 8.7334 13.8415 8.17672 14.5259 8.17672C15.2101 8.17672 15.7668 8.7334 15.7668 9.41758C15.7668 10.1018 15.2101 10.6584 14.5259 10.6584Z",
    fill: "#041967"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99164 0C2.58848 0 2.26172 0.326758 2.26172 0.729922V2.28711C2.26172 2.69027 2.58848 3.01703 2.99164 3.01703C3.3948 3.01703 3.72156 2.69027 3.72156 2.28711V0.729922C3.72156 0.326758 3.3948 0 2.99164 0Z",
    fill: "#041967"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63618 0C8.23301 0 7.90625 0.326758 7.90625 0.729922V2.28711C7.90625 2.69027 8.23301 3.01703 8.63618 3.01703C9.03934 3.01703 9.3661 2.69027 9.3661 2.28711V0.729922C9.3661 0.326758 9.03934 0 8.63618 0Z",
    fill: "#041967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorPrimary);
export default __webpack_public_path__ + "static/media/doctor_primary.66a275b636eda240f9f17bc49f06fc51.svg";
export { ForwardRef as ReactComponent };